import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="w-full bg-background-100 border-t border-background-200 mt-auto">
      <div className="w-full px-4 md:px-8 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-3">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-play-fill text-background-50 text-lg w-5 h-5 flex items-center justify-center"></i>
              </span>
              <span className="text-lg font-heading font-bold">
                <span className="text-primary-500">西瓜</span>
                <span className="text-foreground-900">视频</span>
              </span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              西瓜视频是一个专注于在线视频播放的内容平台，汇集短视频、影视剧、综艺、动漫等丰富内容，为你提供高清流畅、便捷愉悦的观看体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">内容分类</h4>
            <ul className="grid grid-cols-2 gap-y-2 gap-x-4">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.id}`}
                    className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">快捷导航</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  搜索视频
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about-us" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                  版权声明
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold text-foreground-900 mb-3">联系我们</h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500 text-base"></i>
                <a href="mailto:hello@xigua-video.example.com" className="hover:text-primary-600 transition-colors cursor-pointer">
                  hello@xigua-video.example.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-500 text-base"></i>
                <span>400-800-1234</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-500 text-base"></i>
                <span>北京市朝阳区视频大厦 8 层</span>
              </li>
            </ul>
            <div className="flex items-center gap-2 mt-4">
              {["ri-wechat-line", "ri-weibo-line", "ri-bilibili-line", "ri-youtube-line"].map((icon) => (
                <span
                  key={icon}
                  className="w-8 h-8 rounded-md bg-background-200 text-foreground-600 flex items-center justify-center cursor-pointer hover:bg-primary-100 hover:text-primary-600 transition-colors"
                >
                  <i className={`${icon} text-base`}></i>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 text-center sm:text-left">
            © 2024 西瓜视频 · 本平台为演示网站，所有视频内容均为虚构示例，不提供真实视频流播放与下载服务。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-500">用户协议</span>
            <span className="text-xs text-foreground-500">隐私政策</span>
            <span className="text-xs text-foreground-500">意见反馈</span>
          </div>
        </div>
      </div>
    </footer>
  );
}